<div class="pt-safe-top pb-safe-bottom">
  <div id="main-scroll" class="my-12 pt-4 pb-36 px-4 fixed w-full overflow-y-scroll bg-slate-100 min-h-full max-h-full scroll-smooth">
    <ng-content></ng-content>
  </div>
</div>
